// For failed API calls answered by a proxy or CDN in front of our API (its own HTML page, not our JSON):
// which layer rejected the call and how big the cookies were. Used to investigate payment pages whose
// status polling gets HTTP 400 from the proxy (oversized cookies vs Akamai Bot Manager).
// Logs no cookie values and no response body, only the page title and sizes.

const AKAMAI_BOT_MANAGER_COOKIE = /^(_abck|bm_|ak_bmsc)/;

export const getProxyRejectionDiagnostics = (error: any) => {
  try {
    const response = error?.response;
    const contentType = String(response?.headers?.['content-type'] ?? '');
    if (!response || contentType.includes('json')) return undefined;

    const body = typeof response.data === 'string' ? response.data.slice(0, 5000) : '';
    const title = body.match(/<title>([^<]*)<\/title>/i)?.[1]?.trim().slice(0, 200) || 'none';
    const server = String(response.headers?.server ?? 'none').slice(0, 200);
    const jar = document.cookie ? document.cookie.split('; ') : [];

    return {
      tags: {
        'proxy.response_title': title,
        'proxy.server': server,
        'proxy.jar_kb': String(Math.round(document.cookie.length / 1024)),
      },
      // Keys avoid "cookie": Sentry's default scrubbing filters values under such keys
      context: {
        status: response.status,
        title,
        server,
        akamaiReference: body.match(/Reference\s*#\s*([\w.]+)/i)?.[1],
        jarBytes: document.cookie.length,
        jarCount: jar.length,
        akamaiBotManagerBytes: jar
          .filter((entry) => AKAMAI_BOT_MANAGER_COOKIE.test(entry))
          .reduce((total, entry) => total + entry.length, 0),
      },
    };
  } catch {
    // diagnostics must never stop the error from being reported
    return undefined;
  }
};
